<template>
  <div
    :class="{ 'filter blur-sm': false }"
    :data-update="forceUpdate"
    v-show="ready"
  >
    <div class="max-w-6xl  mx-auto px-4 sm:px-6">
      <HeaderSection :banner="banner">
        <h3
          class="text-lg md:text-3xl text-white mb-2"
          v-html="$t('event.intro.title')"
        ></h3>
        <p class="text-white lg:text-lg">
          <span v-html="$t('event.welcomeWord')"></span>
        </p>
      </HeaderSection>
    </div>

    <div class="px-4 mx-auto max-w-6xl sm:px-6">
      <div class="shadow-xl bg-white text-left p-4 md:p-12 md:pb-20">
        <div class="relative m-0 mb-6 sm:mb-0">
          <div
            v-if="publicUrl"
            class="cursor-pointer text-right md:absolute md:top-0 md:right-0"
          >
            <span @click="toggleQr()"
              ><i class="fas fa-share-square"></i> {{ $t("分享") }}</span
            >
          </div>
        </div>

        <h1
          class="
            block
            text-center
            mb-4
            text-lg
            leading-tight
            font-medium
            text-black
            mt-6
          "
          v-html="title()"
        ></h1>

        <span
          class="
            block
            mb-4
            mt-1
            text-sm
            leading-tight
            font-medium
            text-gray-500
          "
          v-html="description()"
        ></span>

        <FormulateForm
          @submit="formSubmit"
          v-model="values"
          @click-mobile-code-btn="
            startCounting(useDebug ? 5 : 60, 'phoneNumber')
          "
          @click-email-code-btn="startCounting(useDebug ? 5 : 60, 'email')"
          @click-refresh-captcha="getCaptcha()"
          @on-verifiy="onVerifiyCodeEvent"
          :schema="formSchema"
          :form-errors="formErrors"
          :errors="inputErrors"
        >
          <!-- <template  v-for="item in formSchema" >

          <FormulateInput
            :key="item.name"
            v-bind="item"
          >          
            <template #label="context">
              {{item}}
              <label
                v-if="context.label"
                :id="`${context.id}_label`"
                :class="context.classes.label"
                :for="context.id"
                v-text="context.label"
              />
            </template>
          </FormulateInput>
        </template> -->

          <div
            v-if="term "
            class="
              md:p-4
              p-4
              mb-2
              border
              text-gray-600
              use-list-disc
              overflow-auto
            "
            style="max-height: 16rem;"
            v-html="term"
          ></div>
          <div
            v-if="eventTerm"
            class="
              md:p-4
              p-4
              mb-2
              border
              text-gray-600
              use-list-disc
              overflow-auto
            "
            style="max-height: 16rem;"
            v-html="eventTerm"
          ></div>

          <FormulateInput
            type="checkbox"
            v-model="acceptTnc"
            :validation-messages="{
              accepted: $t('請同意'),
            }"
            name="acceptTnc"
            :label="$t('同意遵守以上規則') + '*'"
            validation="accepted"
          />
          <FormulateInput type="submit" :label="$t('遞交')" />
        </FormulateForm>

        <!-- <FormulateForm
          @submit="formSubmit"
          v-model="values"
          :schema="formSchema"
          @click-mobile-code-btn="startCounting(5,'phoneNumber')"
          @click-email-code-btn="startCounting(5,'email')"
          @on-verifiy="onVerifiyCodeEvent"
          :form-errors="formErrors"
          :errors="inputErrors"
        >
          <div
            v-if="term"
            class="m-4 p-4 px-8 border text-gray-600 use-list-disc"
            v-html="term"
          ></div>
          <div v-if="false" class="">
            {{ values }}
          </div>

          <div>
formErrors:{{formErrors}}
</div>
<div>
        inputErrors:{{inputErrors}}
        </div>
          
          <FormulateInput type="submit" label="遞交" />
        </FormulateForm> -->

        <div v-if="useDebug" class="cursor-pointer">
          <a target="_blank" :href="adminLink()">form edit link</a>
          <a class="cheatbtn cursor-pointer" @click="useTestData()">█</a>

          {{ values }}
          <br />
          formErrors:{{ formErrors }}
          <br />
          inputErrors:{{ inputErrors }}
          <a class="cheatbtn cursor-pointer" @click="forceFormSubmit()">█</a>
        </div>
      </div>
    </div>

    <!--Modal-->
    <div
      :class="`modal ${
        showQrModal ? '' : 'opacity-0 pointer-events-none'
      }  fixed w-full h-full top-0 left-0 flex items-center justify-center`"
    >
      <div
        class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
      ></div>

      <div
        class="
          modal-container
          bg-white
          w-11/12
          md:max-w-md
          mx-auto
          rounded
          shadow-lg
          z-50
          overflow-y-auto
        "
      >
        <div
          class="
            modal-close
            absolute
            top-0
            right-0
            cursor-pointer
            flex flex-col
            items-center
            mt-4
            mr-4
            text-white text-sm
            z-50
          "
        >
          <svg
            @click="toggleQr()"
            class="cursor-pointer fill-current text-white"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
            ></path>
          </svg>
          <span class="text-sm">(Esc)</span>
        </div>

        <!-- Add margin if you want to see some of the overlay behind the modal-->
        <div class="modal-content py-4 text-left px-6">
          <!--Title-->
          <div class="flex justify-between items-center pb-3">
            <div class="modal-close cursor-pointer z-50">
              <svg
                @click="toggleQr()"
                class="cursor-pointer fill-current text-black"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                ></path>
              </svg>
            </div>
          </div>
          <!--Body-->
          <vue-qrcode
            v-if="publicUrl"
            class="mx-auto"
            :value="publicUrl"
            :options="{ width: 200 }"
            :title="publicUrl"
          ></vue-qrcode>
          <div class="flex flex-col">
            <div v-html="shareText1"></div>
            <textarea
              class="resize-y border rounded-md w-full h-48"
              v-model="shareText2"
              readonly
            ></textarea>
            <textarea
              id="shareText"
              class="hidethis"
              v-model="shareText"
              readonly
            ></textarea>
            <button @click="copyTestingCode" class="btn btn-blue">
              {{ this.$t("複製") }}
            </button>
          </div>

          <!--Footer-->
          <div v-if="false" class="flex justify-end pt-2">
            <button
              class="
                px-4
                bg-transparent
                p-3
                rounded-lg
                text-indigo-500
                hover:bg-gray-100
                hover:text-indigo-400
                mr-2
              "
            >
              Action
            </button>
            <button
              class="
                modal-close
                px-4
                bg-indigo-500
                p-3
                rounded-lg
                text-white
                hover:bg-indigo-400
              "
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// more detail:
// https://dev.to/justinschroeder/tailwind-vue-formulate-24k1

import {
  htmlToText,
  getFormQueryString,
  handleStopError,
  messageTemplateToI18n
} from "../utils/helper";
import CONFIG from "../config";
let { formKey, previewKey, inviteCode, formLang } = getFormQueryString();
console.log({ formKey, previewKey, inviteCode, formLang });
import HeaderSection from "../components/HeaderSection.vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

const useDebug =
  window.location.href.indexOf("127.0.0.1") >= 0 ||
  window.location.href.indexOf("localhost") >= 0;

import {
  getApplyForm,
  submitForm,
  sendMobileVerification,
  sendEmailVerification,
  getCaptcha,
  getMessageTemplate,
  getBannerUrl,
  getFormPublicUrl
} from "../api/fetchEvent";
import { applyFormi18n } from "../utils/helper";
import { updateMessages } from "@/libs/i18n";
import BaseMixin from "./BaseMixin";
import { mapModalComputed } from '../store';

export default {
  mixins: [BaseMixin],
  components: { HeaderSection, VueQrcode },
  watch: {
    "$i18n.locale": function (newVal, oldVal) {
      console.log(`locale change ${oldVal}=>${newVal}`);
      
      const baseForm = window.location.href.split("?")[0];
      let urlParts = []
      urlParts.push(`formKey=${formKey}`);
      urlParts.push(`lang=${newVal}`);
      if(previewKey){
        urlParts.push(`previewKey=${previewKey}`);
      }
      if(inviteCode){
        urlParts.push(`inviteCode=${inviteCode}`);
      }
      const formUrl = `${baseForm}?${urlParts.join('&')}` 
      
      location.href= formUrl;
    //   this.setFormLang(newVal);
    //   this.schema = this.getApplyFormSchema();
      
    //   this.refreshI18n();
    //   setTimeout(() => {
    //     this.refreshTickets();
    //   }, 100);
    },
    "values.ticketId": function (newVal, oldVal) {
      console.log(`ticketId change ${oldVal}=>${newVal}`);
      this.refreshTickets();
      this.refreshI18n();
    },
    "values.attendeeSpeak": function (newVal, oldVal) {
      console.log(`ticketId change ${oldVal}=>${newVal}`);
      this.refreshTickets();
      this.refreshI18n();
    },
    "values.sessionId": function (newVal, oldVal) {
      console.log(`sessionId change ${oldVal}=>${newVal}`);
    },
  },
  methods: {
    handleFormLang(langStr){
      this.formLangs = JSON.parse(langStr)

      // if( this.formLangs.indexOf(formLang) ==-1 ){
      // }
      console.log('handleFormLang', [ this.formLangs ,langStr ] )
    },
    setFormLang(locale){
      if (window.VueFormulate) {
        let formLocale = locale
        if( locale == "zh-hans"){ 
          formLocale = 'hans'
        } else if(locale == "zh-hant"){
          formLocale = 'hant'
        }
        console.log({formLocale});
        window.VueFormulate.setLocale(formLocale);
      }
    },
    adminLink() {
      return `http://dsepdr-admin.staging.wizmacau.com/form/add?id=${
        this.applyForm ? this.applyForm.form.id : ""
      }`;
    },
    copyTestingCode() {
      let testingCodeToCopy = document.querySelector("#shareText");
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        alert(this.$t("分享內容已複制"));
      } catch (err) {
        alert(this.$t("請複制上述內容進行分享"));
      }
    },
    genShareText() {
      //表單分享刪走Facebook；分享頁面須包括的內容 : 活動名稱, 表單名稱, 場次日期時間, 地址, 二維碼, 該頁面的URL (包括複製功能鍵)
      const title = this.title();
      const description = this.description();
      const session = this.getCurrentSession();
      let lines = [];
      let lines2 = [];
      lines.push(title);
      
      if (session) {
        let sessionId = session.id;
        const stitle = this.$t(`session.${sessionId}.title`);
        if (stitle && title!=stitle) lines.push(stitle);
        const stime = this.$t(`session.${sessionId}.eventTimePeriod`);
        if (stime) lines.push(`${this.$t("日期及時間")}: ${stime}`);
        const add = this.$t(`session.${sessionId}.address`);
        if (add) lines.push(`${this.$t("地點")}: ${add}`);
      }
      if (description){
        lines2.push("")
        lines2.push("\n"+description);
      } 
      lines2.push("")
      lines2.push(`${this.$t("連結")}: ${this.publicUrl}`);

      return [ lines.join("\n"), lines2.join("\n") ];
    },
    toggleQr() {
      this.showQrModal = !this.showQrModal;
      let l = this.genShareText();
      this.shareText1 = l[0].replaceAll("\n","<br/>")
      this.shareText2 = htmlToText(l[1])
      this.shareText= htmlToText(l[0])+htmlToText(l[1])
      console.log(this.shareText,this.shareText1,this.shareText2);
    },
    title() {
      const eventTitle = this.trans("event.intro.title");
      const formTitle = this.trans("form.title");
      return formTitle ? formTitle : eventTitle;
    },
    description() {
      const eventTitle = this.trans("event.intro.description");
      const formTitle = this.trans("form.description");
      const cleanTitle = htmlToText(formTitle);
      return cleanTitle ? formTitle : eventTitle;
    },
    useTestData() {
      for (let i in this.abc) {
        this.$set(this.values, i, this.abc[i]);
      }
    },
    refreshValue() {
      for (let i in this.values) {
        let t = this.values[i];
        this.$set(this.values, i, "");
        this.$set(this.values, i, t);
        console.log({ i, t });
      }
    },
    onVerifiyCodeEvent($event) {
      console.log("$event", $event);
    },
    async startCounting(val, field, field2) {
      console.log("startCounting", { field, field2 });
      console.log("this.values", this.values);
      if (field == "phoneNumber") {
        const ok = this.ensureOk("電話", field);
        if (ok) {
          this.isCounting = true;
          this.counting = val;
          let resp = await sendMobileVerification(
            this.values[field],
            this.$i18n.locale
          );
          console.log({ resp });
          this.values.verifyKey = resp.id;
        }
      } else if (field == "email") {
        const ok = this.ensureOk("電郵", field);
        if (ok) {
          this.isCounting = true;
          this.counting = val;
          let resp = await sendEmailVerification(
            "Email verification",
            this.values[field],
            this.$i18n.locale
          );
          console.log({ resp });
          this.values.verifyKey = resp.id;
        }
      } else {
        throw new Error("unknown type for verfiy code");
      }
    },
    getCurrentTicket() {
      if (!this.values.ticketId || !this.applyForm.form.tickets) return false;
      let obj = this.applyForm.form.tickets.filter(
        (t) => t.id == this.values.ticketId
      )[0];
      return obj;
    },
    getCurrentSession() {
      if (!this.values.sessionId || !this.applyForm.form.sessions) return false;
      let obj = this.applyForm.form.sessions.filter(
        (t) => t.id == this.values.sessionId
      )[0];
      return obj;
    },

    refreshTickets() {
      const nameAttendeeSpeak = document.querySelector(".name_attendeeSpeak");
      console.log("nameAttendeeSpeak", nameAttendeeSpeak);
      if (nameAttendeeSpeak) {
        console.log("!");
        let ticket = this.getCurrentTicket();
        console.log("!!");
        console.log({ ticket });
        if (ticket && ticket.allowToSpeak) {
          console.log("!!!");
          console.log("ticket.speakQuota", ticket.speakQuota);
          nameAttendeeSpeak.classList.remove("hidden");
          const theCheckbox = document.querySelector(
            ".name_attendeeSpeak input"
          );
          const theLabel = document.querySelectorAll(
            ".name_attendeeSpeak label"
          )[1];
          console.log("theCheckbox", theCheckbox);
          console.log("theLabel", theLabel);
          if (ticket.speakQuota > 0) {
            theCheckbox.disabled = false;
            theLabel.innerText = this.$t("參加發言");
            theLabel.classList.remove("text-gray-300");
            this.speakStatus = true;
          } else {
            this.values.attendeeSpeak = false;
            theCheckbox.disabled = true;
            theLabel.innerText = `${this.$t("參加發言")}[${this.$t("available_state_full")}]`;
            setTimeout(() => {
              theLabel.classList.add("text-gray-300");
            }, 100);

            this.speakStatus = false;
          }
        } else {
          console.log(">");
          nameAttendeeSpeak.classList.add("hidden");
        }
      }
    },
    refreshI18n() {
      console.log("refreshI18n", window.eventI18n);
      document.title = this.$t(`event.intro.title`);
      console.log("document.title", document.title);
      if (this.values.ticketId) {
        let term = `${this.$t(`ticket.${this.values.ticketId}.description`)}` ;
        if (this.values.attendeeSpeak  ) {
          const t = this.$t(`ticket.${this.values.ticketId}.speakPrecautions`);
          if(t)
            term += `<div class="mt-2">${t}</div>`;
        }
        this.term = term;
      } else {
        this.term = "";
      }
      this.eventTerm = this.$t(`event.intro.precautions`);
      let b = this.eventI18n[this.$i18n.locale]["event.intro.banner"];
      if (b && b.length) {
        this.banner = getBannerUrl(b[0])
      } else {
        this.banner = false;
      }
      this.forceUpdate++;
      this.$forceUpdate();
    },
    async getCaptcha() {
      let captcha = await getCaptcha();
      console.log("getCaptcha", captcha);
      this.values.captchaKey = captcha.captchaKey;
      const captchaButton = document.querySelector("[name=captchaButton]");
      if (captchaButton)
        captchaButton.style =
          "margin-top:26px;width:80px;height:30px;background: url(data:image/png;base64," +
          captcha.imageBase64String +
          ")";
    },
    async getEvent() {
      let err = false;
      try {
        this.applyForm = await getApplyForm(formKey, previewKey, inviteCode);
        if(this.applyForm.form && this.applyForm.form.lang){
          this.handleFormLang(this.applyForm.form.lang)
        }
        
        this.inviteCode = inviteCode;
      } catch (e) {
        console.log("getEvent error", e);
        err = e;
      }
      //retry for non or invalid
      if (err && (err.code == 301003 || err.code == 301004)) {
        let retry = 0;
        const max_retry = 2;
        while (err && retry < max_retry) {
          let inputInviteCode = prompt(
            retry == 0
              ? this.$t("請輸入邀請碼")
              : this.$t("輸入錯誤，請輸入邀請碼")
          );
          retry++;
          err = false;
          try {
            this.applyForm = await getApplyForm(
              formKey,
              previewKey,
              inputInviteCode
            );
            this.inviteCode = inputInviteCode;
          } catch (e) {
            err = e;
          }
        }
      }
      // handle error that stops form showing
      if (err) {
        window.eee = err;
        let errCode = handleStopError("applyFormConfig", err);
        this.$router.push(`/display/${errCode}`);
        return false;
      }

      window.eventI18n = this.eventI18n = applyFormi18n(this.applyForm);
      window.t = (a) => {
        return this.$t(a);
      };

      if (formKey) {
        this.publicUrl = getFormPublicUrl(formKey,formLang)
      }

      window.applyForm = this.applyForm;
      console.log("eventI18n", this.eventI18n);
      updateMessages(this.eventI18n);
      console.log(
        "this.applyForm.form.availableState ",
        this.applyForm.form.availableState
      );
      if (this.applyForm.form.availableState != CONFIG.availableStates.on) {
        this.handleBeforeAfter(this.applyForm.form.availableState);
      }

      this.forceUpdate++;
      return this.applyForm;
    },
    handleBeforeAfter(stateIdx) {
      if(this.applyForm.previewMode){
        return;
      }
      const state = CONFIG.availableState(stateIdx);
      let redirectUrl = false;
      let useStopDialog = false;
      const errorMsgKey = "event-not-available-" + state;
      let dialog = {
        icon: "info",
        back: true,
      };
      switch (state) {
        case "before":
          redirectUrl = this.trans("form.beforePeriodRedirectUrl");
          dialog.icon = 'info'
          if (this.applyForm.form.useBeforeRedirect && redirectUrl) {
            window.location = redirectUrl;
            return false;
          } else {
            dialog.msgKeys = [
              "form.beforePeriod",
              "event-not-available-before",
            ];
            useStopDialog = true;
          }
          break;
        case "after":
          redirectUrl = this.trans("form.afterPeriodRedirectUrl");
          dialog.icon = 'info'
          if (this.applyForm.form.useAfterRedirect && redirectUrl) {
            window.location = redirectUrl;
            return false;
          } else {
            dialog.msgKeys = ["form.afterPeriod", "event-not-available-after"];
            useStopDialog = true;
          }
          break;
        case "other":
          dialog.msg = "other";
          useStopDialog = true;
          break;
        case "full":
          this.handleNoQuota();
          break;
      }
      if (useStopDialog) {
        dialog.useEventI18n = true;
        localStorage.setItem(errorMsgKey, JSON.stringify(dialog));
        this.$router.push(`/display/${errorMsgKey}`);
      }
    },
    handleNoQuota() {
      let dialog = {
        icon: "info",
        back: true,
      };
      const errorMsgKey = "event-no-quota";
      let useStopDialog = false;
      let redirectUrl = this.trans("form.afterPeriodRedirectUrl");
      if (this.applyForm.form.useAfterRedirect && redirectUrl) {
        dialog.msgKeys = ["報名發言配額已達上限"];
        dialog.backUrl = redirectUrl;
        useStopDialog = true;
      } else {
        dialog.msgKeys = ["報名發言配額已達上限"];
        useStopDialog = true;
      }
      if (useStopDialog) {
        dialog.useEventI18n = true;
        localStorage.setItem(errorMsgKey, JSON.stringify(dialog));
        this.$router.push(`/display/${errorMsgKey}`);
      }
    },
    async formSubmit() {
      await this.doSubmit();
    },
    async forceFormSubmit() {
      await this.doSubmit();
    },
    async doSubmit() {
      this.isLoading = true;

      const values = this.values;
      console.log("e", { previewKey, af: this.applyForm });
      let submitValues = {
        name: values.name,
        mobile: values.phoneNumber,
        email: values.email,
        idCard: values.idNumber,
        contact: values.mobile,
        address: values.address,
        organizer: values.organizer ||  values.orgainzer  || values.group,
        position: values.position || values.agency,
        remark: "",
        sessionId: values.sessionId,
        inviteCode: this.inviteCode,
        formKey,
        previewKey,
        ticketIds: [values.ticketId],
        captchaKey: values.captchaKey,
        captchaCode: values.captchaCode,
        channel: values.channel,
        locale: this.$i18n.locale
      };
      console.log({submitValues,values})
      let ticket = this.getCurrentTicket();
      if (ticket.allowToSpeak) {
        submitValues["attendeeSpeak"] = values.attendeeSpeak;
      }

      if (values.verifyCode) {
        submitValues.verifyCode = values.verifyCode;
      }
      if (values.verifyKey) {
        submitValues.verifyKey = values.verifyKey;
      }

      try {
        console.log({ submitValues });
        const data = await submitForm(submitValues);
        console.log({ data });
        window.thankyou = data;
        this.isLoading = false;
        if (data.isSuccess) {
          let successUrl = "/done/" + data.data.uuid;
          //window.location = success
          this.$router.push(successUrl);
        } else {
          alert(data.errorInfo);
        }
      } catch (e) {
        console.log("submit form error now");
        this.isLoading = false;
        window.eeee = e;
        if (e.code && e.code == "304001") {
          this.handleNoQuota();
        } else if (e.code && CONFIG.errors.attendeesSubmit[e.code]) {
          alert(this.$t(CONFIG.errors.attendeesSubmit[e.code]));
        } else {
          if (e.source && e.source.errorInfo) {
            let einfo = e.source.errorInfo;
            let detail = "";
            if (einfo.validationErrors && einfo.validationErrors.length) {
              console.log({ "einfo.validationErrors": einfo.validationErrors });
              detail =
                "\n" + einfo.validationErrors.map((v) => v.message).join("\n");
            }
            console.log({ detail });
            let em = this.$te(e.source.errorInfo.message)
              ? this.$t(e.source.errorInfo.message)
              : e.source.errorInfo.message;
            let msg = `${em}${detail}`;
            alert(msg);
          } else {
            alert(e);
          }
        }
        console.log("doSubmit", e);
      }
    },
    getBasicSchema() {
      return [];
    },
    getApplyFormSchema() {
      const that = this;
      let schema = this.getBasicSchema();

      let valid_session_count = 0;
      let sessionOptions = this.applyForm.form.sessions
        .map((t) => {
          let lines = [];
          const disabled = t.availableState != CONFIG.availableStates.on;
          //let no = t.code ? t.code : '';
          const title = this.$t(`session.${t.id}.title`);
          lines.push(title);
          const time = this.trans(`session.${t.id}.eventTimePeriod`);
          if (time) lines.push(`${this.$t("日期及時間")}: ${time}`);
          const add = this.trans(`session.${t.id}.address`);
          if (add) lines.push(`${this.$t("地點")}: ${add}`);
          //let extra = `<span>this.$t('available_state_${CONFIG.availableState(t.availableState)}')</span>`;
          let label = lines
            .map(
              (l, i) =>
                `<div class="${
                  i == 0 ? "text-current" : "text-gray-600"
                }">${l}</div>`
            )
            .join("");
          if (!t.isEnable) return false;

          if (!disabled) {
            valid_session_count++;
          }
          return {
            value: t.id,
            id: `session_${t.id}`,
            disabled,
            label,
            useHtml: true,
            groupCount: this.applyForm.form.sessions.length,
          };
        })
        .sort((a, b) => a.value * 1 - b.value * 1)
        .filter((o) => o);

      if (valid_session_count == 0 && sessionOptions.length == 1) {
        this.handleBeforeAfter(this.applyForm.form.sessions[0].availableState);
      }
      // build tickets:
      let valid_ticket_count = 0;
      let attendeeAllowSpeak = false;
      let joinOptions = this.applyForm.form.tickets
        .map((t) => {
          let disabled = t.availableState != CONFIG.availableStates.on;
          let label = this.$t(`ticket.${t.id}.title`);
          let extra =
            t.availableState != CONFIG.availableStates.on
              ? this.$t(
                  `available_state_${CONFIG.availableState(t.availableState)}`
                )
              : "";
          if (!t.isEnable) return false;

          if (t.quota != 0 && t.useQuota >= t.quota) {
            disabled = true;
            //label = `${label} (${this.$t("已滿額")}) `;
          }
          if (extra) label = `${label} [${extra}]`;
          if (!disabled) {
            valid_ticket_count++;
          }
          const canSpeak = t.allowToSpeak;
          if (canSpeak) {
            attendeeAllowSpeak = true;
          }
          //console.log('ticket',{t,disabled,label})
          return {
            value: t.id,
            id: `ticket_${t.id}`,
            disabled,
            label,
            groupCount: this.applyForm.form.tickets.length,
          };
        })
        //.sort((a, b) => a.value * 1 - b.value * 1)
        .filter((o) => o);

      let s = {
        type: "radio",
        name: "sessionId",
        label: this.$t("報名的場次"),
        options: sessionOptions,
        validation: "required",
      };
      if (valid_session_count === 1) {
        sessionOptions.map((o) => {
          if (!o.disabled) {
            this.$set(this.values, "sessionId", `${o.value}`);
          }
        });
      }
      console.log({ valid_session_count });
      schema.push(s);

      this.applyForm.form.formConfig
        .map((field_config) => {
          if (field_config.hidden) return false;
          let field = field_config.field;
          let f = {
            label: this.$t(field_config.module),
            name: field,
            validation: "",
            maxlength: 255,
            id: field
          };
          let extra_f1 = false;
          let extra_f2 = false;
          if (field == "email") {
            f.validation = "email";
            if (field_config.use_validation_code) {
              extra_f1 = {
                type: "hidden",
                name: "verifyKey",
                value: "-",
              };
              extra_f2 = {
                related: "email",
                component: "div",
                class: "flex w-full",
                children: [
                  {
                    label: "",
                    placeholder: this.$t("驗證碼"),
                    name: "verifyCode",
                    validation:
                      "optional|matches:/^.{6}$/|verifyCodeRule:verifyKey,verifyCode",
                    maxlength: 6,
                    class: "w-1/2 mr-2",
                    validationMessages: {
                      verifyCodeRule: this.$t("驗證碼不正確"),
                    },
                    "@validation": "on-verifiy",
                  },
                  {
                    label: this.$t(`收取驗證碼`),
                    name: "check-code-btn",
                    type: "button",
                    disabled: this.isCounting,
                    "@click": "click-email-code-btn",
                  },
                ],
              };
            }
          } else if (field == "idNumber") {
            f.validation = "matches:/^\\d{8}$/";
          } else if (field == "phoneNumber") {
            f.validation = "matches:/6\\d{7}/";
            f.help = this.$t(`請輸入8位澳門流動電話號碼`);
            f.maxlength = 8;
            f.type = "tel";
            if (field_config.use_validation_code) {
              extra_f1 = {
                type: "hidden",
                name: "verifyKey",
                value: "-",
              };
              extra_f2 = {
                related: "mobile",
                component: "div",
                class: "flex w-full",
                children: [
                  {
                    label: "",
                    placeholder: this.$t("驗證碼"),
                    name: "verifyCode",
                    validation:
                      "optional|matches:/^.{6}$/|verifyCodeRule:verifyKey,verifyCode",
                    maxlength: 6,
                    class: "w-1/2 mr-2",
                    validationMessages: {
                      verifyCodeRule: this.$t("驗證碼不正確"),
                    },
                    "@validation": "on-verifiy",
                  },
                  {
                    label: this.$t(`收取驗證碼`),
                    name: "check-code-btn",
                    type: "button",
                    disabled: this.isCounting,
                    "@click": "click-mobile-code-btn",
                  },
                ],
              };
            }
          }
          if (field_config.required) {
            if (f.validation) {
              f.validation =
                "^required|" + f.validation.replace("optional|", "");
            } else {
              f.validation = "^required";
            }
            f.label = f.label + "*";
          } else {
            if (f.validation) {
              //console.log("row.validation", row.validation);
              f.validation = "optional|" + f.validation;
            }
          }
          if (f) schema.push(f);
          if (extra_f1) schema.push(extra_f1);
          if (extra_f2) schema.push(extra_f2);
        })
        .filter((f) => f);

      if (this.applyForm.form.isValidateCaptcha) {
        schema.push({
          type: "hidden",
          name: "captchaKey",
          value: "-",
        });
        schema.push({
          related: "captcha",
          component: "div",
          class: "flex w-full",
          children: [
            {
              label: this.$t("驗證碼"),
              placeholder: this.$t("驗證碼"),
              name: "captchaCode",
              validation: "optional|verifyCodeRule:captchaKey,captchaCode,true",
              maxlength: 4,
              class: "w-2/3 sm:w-1/2 mr-2",
              validationMessages: {
                verifyCodeRule: function () {
                  console.log("validationMessages-verifyCodeRule", {
                    arguments,
                  });
                  if (window.captchaMessage) {
                    return that.$t(window.captchaMessage);
                  } else {
                    return that.$t("驗證碼不正確");
                  }
                },
              },
              "@validation": "on-verifiy",
            },
            {
              type: "button",
              label: " ",
              class: "",
              name: "captchaButton",
              "@click": "click-refresh-captcha",
            },
          ],
        });
      }

      const mapping = {
        name: "name",
        phoneNumber: "mobile",
        email: "email",
        address: "address",
        idNumber: "bir",
      };
      let hideFields = [];
      let fieldConfig = {};
      this.applyForm.form.formConfig.map((field_config) => {
        const schemaKey = mapping[field_config.field];
        if (field_config.hidden) {
          hideFields.push(schemaKey);
        }
        fieldConfig[schemaKey] = field_config;
      });

      // schema post process -- like setting vladiation
      schema = schema
        // .filter((row) => {
        //   if (row.related && hideFields.indexOf(row.related) !== -1) {
        //     console.log(`hide related ${row.related}`, { row });
        //     return false;
        //   }
        //   if (!row.name) {
        //     console.log("pass no name", { row });
        //     return true;
        //   }
        //   if (hideFields.indexOf(row.name) == -1) {
        //     console.log(`pass no hide ${row.name}`, { row });
        //     return true;
        //   }

        //   console.log(`hide ${row.name}`, { row });
        //   return false;
        // })
        .map((row) => {
          if (!row["validation-name"] && row["label"]) {
            row["validation-name"] = row["label"];
          }
          return row;
        });

      // build tickets:
      let o = {
        type: "radio",
        name: "ticketId",
        label: this.$t("報名種類"),
        options: joinOptions,
        validation: "required",
      };

      if (valid_ticket_count === 0) {
        if (joinOptions.length == 1) {
          this.handleBeforeAfter(this.applyForm.form.tickets[0].availableState);
        } else {
          this.handleNoQuota();
        }
      } else if (valid_ticket_count === 1) {
        joinOptions.map((o) => {
          if (!o.disabled) {
            console.log("set only ticket$$$$");
            this.$set(this.values, "ticketId", `${o.value}`);
          }
        });
      }
      schema.push(o);

      // theLabel.innerText = `${this.$t( "參加發言")}[${this.$t('已滿額')}]`
      //       theLabel.classList.add('text-gray-300')
      console.log({ attendeeAllowSpeak });
      if (attendeeAllowSpeak) {
        const speakCheckbox = {
          type: "checkbox",
          name: "attendeeSpeak",
          label: this.$t("參加發言"),
          class: "hidden",
        };
        schema.push(speakCheckbox);
      }

      // let tnc = {
      //   type: "checkbox",
      //   name: "tnc",
      //   label: this.$t( "同意以上條款"),
      //   validation: "required",
      //   "label-position":"before"
      // };
      // schema.push(tnc)
      return schema;
    },
  },
  async mounted() {
    const that = this;
    this.setFormLang(this.$i18n.locale);
    
    console.log("window.$vue", window.$vue);
    if (window.$vue) {
      console.log("refreshCaptcha hook");
      window.$vue.$on("verifyCodeRule", async function () {
        console.log("verifyCodeRule fired");
      });
      window.$vue.$on("refreshCaptcha", async function () {
        console.log("refreshCaptcha fired");
        await that.getCaptcha();
      });
    }
    //this.schema = this.getSchema();
    this.isLoading = false;
    let data = await this.getEvent(formKey);
    console.log("mounted", { data });
    if (!data) {
      return;
    }

    let userMessage = false
    let msgTemplateRaw = await getMessageTemplate("term");
    if(msgTemplateRaw){
      userMessage = messageTemplateToI18n(msgTemplateRaw)
    }
    window.userMessage = userMessage
    if(userMessage){
      console.log('updateMessages',{userMessage})
      updateMessages(userMessage)
    }
    this.schema = this.getApplyFormSchema();

    this.isLoading = true;

    this.ready = true;
    this.countingHandler = setInterval(() => {
      if (this.isCounting) {
        this.counting = this.counting - 1;
        const smsbtn = document.querySelector("button[name=check-code-btn]");
        if (smsbtn) {
          smsbtn.textContent = this.$t(`收取驗證碼`) + `(${this.counting})`;
          smsbtn.disabled = true;
        }

        if (this.counting <= 0) {
          this.isCounting = false;
          this.counting = 0;
          smsbtn.textContent = this.$t(`收取驗證碼`);
          smsbtn.disabled = false;
        }
        //: this.counting });
      }
    }, 1000);
    if (this.applyForm.form.isValidateCaptcha) {
      await this.getCaptcha();
    }

    this.refreshI18n();
    setTimeout(() => {
      this.refreshTickets();
    }, 100);
    setTimeout(() => {
      this.refreshTickets();
    }, 1000);
  },
  created() {},
  computed: {
    formSchema() {
      return this.schema;
    },
    ...mapModalComputed()

  },
  errorCaptured(err, vm, info) {
    console.log(`cat EC: ${err.toString()}\ninfo: ${info}`);
    return false;
  },
  data() {
    return {
      useDebug,
      inviteCode: false,
      ready: false,
      banner: "",
      formErrors: [],
      inputErrors: {},
      forceUpdate: 0,
      isValid: false,
      isLoading: false,
      isCounting: false,
      counting: 0,
      schema: [],
      values: {},
      term: false,
      eventTerm: false,
      publicUrl: false,
      showQrModal: false,
      acceptTnc: false,
      attendeeSpeak: true,
      channel: false,
      shareText: "",
      shareText1: "",
      shareText2: "",
      abc: {
        name: "Test from Form",
        email: "snakewa+test@gmail.com",
        phoneNumber: "61234567",
        sms_code: "1234",
        idNumber: "12345678",
        session_id: "1",
        agency: "agency",
        group: "group",
        address: "address" + new Date().toLocaleString(),
      },
    };
  },
};
</script> 
<style scoped>
.cheatbtn {
  opacity: 3%;
}

[name="captchaButton"] {
  min-width: 100px;
}

.modal {
  transition: opacity 0.25s ease;
}
body.modal-active {
  overflow-x: hidden;
  overflow-y: visible !important;
}

.hidethis{
     opacity: 0;
  position: absolute;
  z-index: -9999;
  pointer-events: none;
}
</style>